// extracted by css-extract-rspack-plugin
export default {"tile":"_6350aff8","imageWrapper":"_723c3d58","shimmerLoadingBackground":"_492e8241"};